import {Injectable} from "@angular/core";
import {ApiService} from "../../../../services/api.service";
import {SweetalertService} from "../../../../services/sweetalert.service";
import {Subject} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {ErrorService} from '../../../../services/error.service';

@Injectable()
export class ScholarshipListService {
  public status;
  public isLoading;
  private observer: any = new Subject();
  public scholarships = this.observer.asObservable();

  constructor(
    private apiService: ApiService,
    private sweetalertService: SweetalertService,
    private activatedRoute: ActivatedRoute,
    private errorService: ErrorService,
    private router: Router,
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (this.router.url.startsWith('/admin/scholarship')) {
        this.status = params['status'];
        this.refreshScholarshipList(params['status']);
      }
    });
  }

  public refreshScholarshipList(scholarshipStatus = this.status) {
    this.isLoading = true;
    this.apiService.getScholarships({scholarshipStatus: scholarshipStatus}).subscribe((response: any) => {
      this.isLoading = false;
      this.observer.next(response.data);
    }, error => {
      this.errorService.handleError(error);
    })
  }
}
